export default __webpack_public_path__ + "static/media/delete.757e83fb.svg";